import { FC } from "react";
import { Button, DrawerCloseButton, Flex, Text } from "@chakra-ui/react";
import { setMobileDrawerContent } from "~/features/MobileDrawerContent";
import { ChevronLeft, XClose } from "~/icons";
import { useAppDispatch } from "~/store/hooks";
import { Logo } from "./Logo";
import { useMobileDrawerContent } from "./useMobileDrawerContent";

export const MobileNestedDrawerHeader: FC = () => {
  const dispatch = useAppDispatch();
  const drawerContent = useMobileDrawerContent();
  const isDefault = drawerContent === "default";

  const main =
    drawerContent === "default" ? (
      <Logo monitor="mobile" />
    ) : (
      <Text variant="th-t3" textAlign="center">
        {drawerContent}
      </Text>
    );

  return (
    <Flex
      align="center"
      h={6}
      justify="center"
      mt={1}
      position="relative"
      w="full"
    >
      {!isDefault && (
        <Button
          left={-3}
          onClick={() => dispatch(setMobileDrawerContent("default"))}
          position="absolute"
          px="none"
          variant="th-button-text"
        >
          <ChevronLeft />
        </Button>
      )}
      {main}
      <DrawerCloseButton as={XClose} h={6} right={0} top={0} w={6} />
    </Flex>
  );
};
